import { mapperModuleNavigationLink } from '../../../../core/data-layer/modules/mappers'
import mapperModuleReportsListItem from '../../modules/module-reports-list-item/mapper-module-reports-list-item'
import type { MapperOptions } from '#layers/core/types'

/**
 * Block Reports List mapper
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  return {
    id: data.sys?.id || '',
    contentType: data.contentType || '',
    title: data.title || '',
    items: data.itemsCollection?.items?.map((item: any) => mapperModuleReportsListItem(item, options)) || [],
    previousReportsLink: mapperModuleNavigationLink(data.previousReportsLink, options.getUrl)
  }
}
